import IngredientCreate from './IngredientCreate'
export {IngredientCreate}
export default IngredientCreate
